export const environment = {
  production: false,
  //api: "https://captaciones-int-dev.apps.ambientesbc.com/subsidios/subsidios-nuevosempleos/api/nuevos_empleos"
  //api: "http://localhost:8080/api/nuevos_empleos",
  api:'#{api}#'
};
